import src from "IMAGE";
export default { src, width: 32, height: 32, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
